export default __webpack_public_path__ + "media/main-video.f8139d73.mov";